import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import api from '../../services/api';

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState({ type: '', msg: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/auth/forgot-password', { email });
            setStatus({ type: 'success', msg: 'Vérifiez votre boîte mail.' });
        } catch {
            setStatus({ type: 'danger', msg: 'Erreur lors de la demande.' });
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center min-vh-100">
            <Card style={{ width: '400px' }} className="shadow border-0 rounded-4 p-3">
                <h3 className="text-center mb-4">Mot de passe oublié ?</h3>
                {status.msg && <Alert variant={status.type}>{status.msg}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Label>Entrez votre email d'administrateur</Form.Label>
                    <Form.Control type="email" required onChange={(e) => setEmail(e.target.value)} className="mb-3" />
                    <Button variant="danger" type="submit" className="w-100 fw-bold">Envoyer le lien</Button>
                </Form>
            </Card>
        </Container>
    );
};

export default ForgotPassword;